import * as React from 'react'
import styled from 'styled-components'
import HttpRequest from 'src/api/HttpRequest'
import {
  ConfiguratorBox,
  HighlightInBox
} from 'src/components/containers/configurator/ConfiguratorBox'
import { StoreProps } from 'src/stores'
import { observer, inject } from 'mobx-react'
import { FuneralType } from 'src/resources'
import Link from 'src/components/atoms/input/buttons/Link'
import IconText from 'src/components/atoms/IconText'

const mailIcon = require('src/assets/envelope.png')
const whatsappIcon = require('src/assets/whatsapp.png')
const contentDisposition = require('content-disposition');

@inject('confStore')
@observer
export class Success extends React.Component<StoreProps> {
  componentDidMount() {
    const { confStore } = this.props
    if (confStore.isOfferLoaded)
      HttpRequest.get(confStore.getOffer.offerDownloadUrl + "/", [
        {
          responseType: 'blob'
        }
      ]).then((response) => {
        // const offer = confStore.getOffer
        const downloadUrl = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = downloadUrl
        link.setAttribute(
          'download',
          contentDisposition.parse(response.headers['content-disposition']).parameters.filename)
        document.body.appendChild(link)
        link.click()
        link.remove()
      })
  }

  stringifyFuneralType = (ft: FuneralType) => {
    switch (ft) {
      case 'BURIAL':
        return 'Erbestattung'
      case 'CREMATION':
        return 'Feuerbestattung'
      case 'TREE_FUNERAL':
        return 'Baumbestattung'
      case 'SEA_FUNERAL':
        return 'Donaubestattung'
      default:
        return 'ERROR'
    }
  }

  renderAppointment = () => {
    const { confStore } = this.props
    if (confStore.getOffer.appointment) {
      return (
        <HighlightInBox>
          <p>
            <strong>
              <i className='fas fa-check' /> Anfrage eingelangt
            </strong>
          </p>
          <p>
            Wir haben Ihre Anfrage bezüglich eines Beratungsgesprächs
            erfolgreich erhalten und melden uns bei Ihnen, um den Termin zu
            bestätigen.
          </p>
        </HighlightInBox>
      )
    }
    return (
      <Link to={`/planung/vorsorge/termin/${confStore.getOffer.uuid}`}>
        Jetzt Beratungstermin vereinbaren
      </Link>
    )
  }

  render() {
    const { confStore } = this.props

    if (!confStore.isOfferLoaded) return null
    // Salesforce Integration: this command is not necessary.
    // There aren't delay of 5s like zoho integration
    // HttpRequest.get(confStore.getOffer.offerDownloadUrl)

    const offer = confStore.getOffer
    const greeting =
      offer.contactDetails.greeting === 'MR'
        ? 'Sehr geehrter Herr '
        : 'Sehr geehrte Frau '
    return (
      <>
        <ConfiguratorBox title='Bestätigung'>
          <p>
            {greeting}
            {offer.contactDetails.lastName},
          </p>
          <p>
            vielen Dank, dass Sie eine Vorsorgeplanung bei Benu erstellt haben.
          </p>
          <div className='product-long-desc'>
            <ul>
              <li>Ihre Planung wurde erfolgreich gespeichert</li>
              <li>
                Wir haben Ihnen eine E-Mail mit Ihrer persönlichen
                Vorsorge&shy;planung an folgende E-Mail Adresse geschickt:{' '}
                <u>{offer.contactDetails.email}</u>
              </li>
              <li>
                Ihre persönliche Vorsorgeplanung wird in Kürze heruntergeladen (
                <a href={offer.offerDownloadUrl} target='_blank'>
                  nochmal herunterladen
                </a>
                )
              </li>
            </ul>
          </div>
          <HighlightInBox>
            <p>
              <strong>Sie wollen Ihre Planung weiter anpassen?</strong>
            </p>
            <p>
              Kehren Sie jederzeit einfach zu Ihrer Vorsorgeplanung zurück, um
              diese nach Ihren Wünschen anzupassen. Gerne unterstützen wir Sie
              auch telefonisch oder per E-Mail.
            </p>
            <BackToConfigurator light to={`/planung/detailplanung/${offer.uuid}`}>
              Zurück zur Planung
            </BackToConfigurator>
          </HighlightInBox>
        </ConfiguratorBox>
        <ConfiguratorBox title='Wie geht es jetzt weiter?'>
          <p>
            <strong>
              1. Bestattung telefonisch besprechen und Bestattungsverfügung
              anlegen (kostenfrei & unverbindlich)
            </strong>
          </p>
          <p>
            Wir nehmen uns Zeit für die Beratung. Telefonisch besprechen wir
            Ihre Bestattungswünsche und informieren Sie umfassend. Unsere
            Bestattungsexperten helfen Ihnen dabei, eine Bestattung nach Wunsch
            zu planen, geben Ihnen eine detaillierte Kostenauskunft und
            erarbeiten zusammen mit Ihnen Ihre persönliche Wunschbestattung.
          </p>
          <p>
            Danach erhalten Sie von uns – völlig unverbindlich –
            Ihre persönliche Benu-Vorsorgemappe per Post zu Ihnen nach Hause
            zugesandt. Darin finden Sie Ihre persönliche Bestattungsplanung,
            die Sie zusammen mit Ihren anderen wichtigen Dokumenten aufbewahren
            können.
          </p>
          <p>
            <strong>2. Vorsorge abschließen und finanziell absichern</strong>
          </p>
          <p>
            Um im Fall der Fälle eine Bestattung nach Wunsch zu gewährleisten
            und die eigene Familie vor finanzieller Belastung zu schützen,
            empfiehlt sich der Abschluss einer finanziellen Bestattungsvorsorge.
            Eine umfassende Vorsorge enthält daher einen organisatorischen, als
            auch einen finanziellen Teil.
          </p>
          <p>
            Eine sehr gute Lösung für die finanzielle Bestattungsvorsorge ist ein
            Treuhandkonto. Es garantiert die Sicherheit Ihres Geldes zu 100% und
            ermöglicht die Durchführung einer Bestattung nach Wunsch. Benu
            bietet hierfür eine kostengünstige und absolut sichere Lösung an.
            Erleben Sie das gute Gefühl, für das eigene Ableben vorgesorgt zu
            haben.
          </p>
          {this.renderAppointment()}
          <p>
            Bei Fragen zu Ihrer Bestattungsvorsorgeplanung oder zur
            Terminvereinbarung für Ihr persönliches Beratungsgespräch können Sie
            sich jederzeit gerne an uns wenden:
          </p>
          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'space-evenly'
            }}>
            <IconText icon={mailIcon}>
              <a href='mailto:kontakt@benu.at'>E-Mail an kontakt@benu.at</a>
            </IconText>
            <IconText icon={whatsappIcon}>
              <a
                href={`https://wa.me/43800884404?text=Ich%20habe%20eine%20Frage%20zu%20meiner%20Bestattungsvorsorge"${offer.orderId}"`}
                target='_blank'>
                WhatsApp an 0800884404
              </a>
            </IconText>
          </div>
        </ConfiguratorBox>
      </>
    )
  }
}

const BackToConfigurator = styled(Link)`
  margin: 7.5px auto;
  padding: 7.5px;
`

export default Success



// WEBPACK FOOTER //
// ./src/components/organisms/checkout/SuccessProvision.tsx